// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3G4_t","label":"Radio_label__3XqRr","checkMark":"Radio_checkMark__FyptX","disabled":"Radio_disabled__1ge7V"};